import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-lsa-dark text-white py-20 px-5 text-center" data-id="element-72">
      <div className="max-w-xl mx-auto" data-id="element-73">
        <h2 className="text-[28px] sm:text-[32px] font-bold mb-10 leading-tight" data-id="element-74">
          La próxima vez que estés frente a una persona sorda, vas a poder
          comunicarte. <span className="text-3xl align-middle ml-1" data-id="element-75">🤟</span>
        </h2>

        <div className="flex flex-col gap-4 mb-10" data-id="element-76">
          <button onClick={scrollToPricing} className="w-full bg-lsa-cyan hover:brightness-110 text-lsa-deep h-[64px] rounded-xl font-bold text-[18px] transition-all shadow-lg shadow-lsa-cyan/30 flex items-center justify-center gap-2" data-id="element-77">
            <span className="text-xl" data-id="element-78">🤟</span> Quiero el Sistema LSA Fácil
          </button>

          <button onClick={scrollToPricing} className="w-full bg-transparent border-2 border-white/30 hover:border-white text-white h-[64px] rounded-xl font-bold text-[18px] transition-colors flex items-center justify-center gap-2" data-id="element-79">
            <span className="text-xl" data-id="element-80">🚀</span> Quiero el Plan Profesional
          </button>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-[13px] text-white/70 font-medium" data-id="element-81">
          <span className="flex items-center gap-1.5" data-id="element-82">
            <ShieldCheck size={16} className="text-lsa-celeste" data-id="element-83" /> Garantía 7
            días
          </span>
          <span className="hidden sm:inline" data-id="element-84">·</span>
          <span className="flex items-center gap-1.5" data-id="element-85">
            <Lock size={16} className="text-lsa-celeste" data-id="element-86" /> Pago seguro
          </span>
          <span className="hidden sm:inline" data-id="element-87">·</span>
          <span className="flex items-center gap-1.5" data-id="element-88">
            <Zap size={16} className="text-lsa-celeste" data-id="element-89" /> Acceso inmediato
          </span>
        </div>
      </div>
    </section>;
}